// components/layout/Footer/index.jsx
import React from "react";
import { Facebook, Instagram } from "lucide-react";
import {
	FooterWrapper,
	FooterContainer,
	FooterSection,
	FooterList,
	FooterLink,
	SocialLinks,
	SocialLink,
	BottomBar,
} from "./styles";

const Footer = () => {
	const currentYear = new Date().getFullYear();

	const handleClick = () => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	};

	return (
		<FooterWrapper>
			<FooterContainer>
				<FooterSection>
					<h3>Le Petit</h3>
					<p>
						Capturing precious moments of your little ones with professional
						photography services tailored for babies and families.
					</p>
					<SocialLinks>
						<SocialLink
							href="https://www.facebook.com/profile.php?id=61571976815468"
							target="_blank"
							rel="noopener noreferrer"
						>
							<Facebook size={20} />
						</SocialLink>
						<SocialLink
							href="https://www.instagram.com/lepetitpromise/"
							target="_blank"
							rel="noopener noreferrer"
						>
							<Instagram size={20} />
						</SocialLink>

					</SocialLinks>
				</FooterSection>

				<FooterSection>
					<h3>Services</h3>
					<FooterList>
						<li>
							<FooterLink to="/pricing" onClick={handleClick}>
								Pricing Plans
							</FooterLink>
						</li>
						<li>
							<FooterLink to="/pricing" onClick={handleClick}>
								Package Details
							</FooterLink>
						</li>
						<li>
							<FooterLink to="/gallery" onClick={handleClick}>
								Photo Gallery
							</FooterLink>
						</li>
						<li>
							<FooterLink to="/faq" onClick={handleClick}>
								FAQ
							</FooterLink>
						</li>
					</FooterList>
				</FooterSection>

				<FooterSection>
					<h3>Company</h3>
					<FooterList>
						<li>
							<FooterLink to="/about" onClick={handleClick}>About Us</FooterLink>
						</li>
						<li>
							<FooterLink to="/contact" onClick={handleClick} >Contact</FooterLink>
						</li>
						<li>
							{/* <FooterLink to="/careers" onClick={handleClick}>Careers</FooterLink> */}
						</li>
					</FooterList>
				</FooterSection>

				<FooterSection>
					<h3>Legal</h3>
					<FooterList>
						<li>
							<FooterLink to="/privacy" onClick={handleClick}>Privacy Policy</FooterLink>
						</li>
						<li>
							<FooterLink to="/terms" onClick={handleClick}>Terms of Service</FooterLink>
						</li>
						<li>
							<FooterLink to="/cookies" onClick={handleClick}>Cookie Policy</FooterLink>
						</li>
					</FooterList>
				</FooterSection>
			</FooterContainer>

			<BottomBar>© {currentYear} Le Petite by LensCraft. All rights reserved.</BottomBar>
		</FooterWrapper>
	);
};

export default Footer;
